
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 1.086A6.42 6.42 0 0113.914 7.5 6.42 6.42 0 017.5 13.914 6.42 6.42 0 011.086 7.5 6.42 6.42 0 017.5 1.086m0-1a7.415 7.415 0 10.002 14.83A7.415 7.415 0 007.5.086z"}}),_c('circle',{attrs:{"cx":"4.39","cy":"6.809","r":".898"}}),_c('circle',{attrs:{"cx":"10.61","cy":"6.809","r":".898"}}),_c('path',{attrs:{"d":"M5.287 12.18a.498.498 0 01-.444-.725c.051-.099 1.284-2.418 5.409-2.418a.5.5 0 010 1c-3.476 0-4.48 1.801-4.521 1.877a.503.503 0 01-.444.266zM3.071 5.482a.25.25 0 01-.156-.445c.044-.036 1.103-.871 2.373-.871a.25.25 0 010 .5c-1.096 0-2.051.754-2.061.762a.25.25 0 01-.156.054zM11.929 5.482a.248.248 0 01-.156-.055c-.01-.008-.968-.762-2.061-.762a.25.25 0 010-.5c1.271 0 2.329.836 2.373.871a.25.25 0 01-.156.446z"}})])
          )
        }
      }
    